import React, { FC, ReactNode } from 'react';

import { Box, BoxProps, Stack, StackProps, Text } from '@chakra-ui/react';
import { isBoolean, isNumber } from 'lodash';
import { customTheme } from 'theme';

import {
  DetailsIdentifier,
  DetailsIdentifierProps,
} from 'components/DataDisplay';

export interface DetailsFieldProps extends DetailsIdentifierProps {
  placeholder?: string;
  flex?: string | number;
  width?: string | number;
  darkMode?: boolean;
}

export const DetailsField: FC<DetailsFieldProps> = props => {
  const {
    value,
    flex = '',
    placeholder = '',
    styles = {},
    darkMode,
    width,
    ...rest
  } = props;
  const formatBoolean = value => (value ? 'Yes' : 'No');

  return (
    <DetailsIdentifier
      styles={{
        label: { color: 'black', ...styles.label },
        value: { color: customTheme.colors.gray['300'], ...styles.value },
      }}
      value={
        isBoolean(value)
          ? formatBoolean(value)
          : isNumber(value)
          ? `${value}`
          : value
          ? value
          : placeholder || '-'
      }
      {...rest}
    />
  );

  /*return (
    <Box flex={flex} w={width}>
      <Stack
        spacing={spacing}
        align="start"
        direction={isInline ? 'row' : 'column'}
        {...rest}
      >
        <Text
          fontWeight={600}
          whiteSpace="nowrap"
          spacing={0}
          {...styles?.label}
        >
          {}
          {showColon && ':'}
        </Text>

        <Box
          color={
            darkMode
              ? customTheme.colors.gray['200']
              : customTheme.colors.gray['300']
          }
          {...styles.value}
          flex={1}
          w="full"
        >
          {isBoolean(value)
            ? formatBoolean(value)
            : isNumber(value)
            ? `${value}`
            : value
            ? value
            : placeholder || '-'}
        </Box>
      </Stack>
    </Box>
  );*/
};
